/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Search_Text_LabelInputs */

const en_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Text`)
};

const fr_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher du texte`)
};

const de_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchbegriff`)
};

const it_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca testo`)
};

const ru_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск текста`)
};

const es_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar texto`)
};

const zh_cn2_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索文本`)
};

const ja_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索テキスト`)
};

const hi_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज पाठ`)
};

const pt_pt2_editor_search_text_label = /** @type {(inputs: Editor_Search_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de pesquisa`)
};

/**
* | output |
* | --- |
* | "Search Text" |
*
* @param {Editor_Search_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_search_text_label = /** @type {((inputs?: Editor_Search_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Search_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_search_text_label(inputs)
	if (locale === "de") return de_editor_search_text_label(inputs)
	if (locale === "it") return it_editor_search_text_label(inputs)
	if (locale === "ru") return ru_editor_search_text_label(inputs)
	if (locale === "es") return es_editor_search_text_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_search_text_label(inputs)
	if (locale === "ja") return ja_editor_search_text_label(inputs)
	if (locale === "hi") return hi_editor_search_text_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_search_text_label(inputs)
	return en_editor_search_text_label(inputs)
});